import { useTranslation } from 'react-i18next'

import { Question } from '../../common/types'
import useModalLabels from '../hooks/useModalLabels'
import { pickQuestionExplanation } from '../hooks/useQuestions'
import AppMarkdown from './common/AppMarkdown'
import HyButton from './common/hy/HyButton'
import HyModal from './common/hy/HyModal'

const ExtraInfoModal = ({
  question,
  open,
  handleClose,
  currentVariant,
}: {
  question: Question
  open: boolean
  handleClose: () => void
  currentVariant?: string
}) => {
  const { t } = useTranslation()
  const modalLabels = useModalLabels()

  const explanationToShow = pickQuestionExplanation(currentVariant, question, t)

  return (
    <HyModal
      open={open}
      onClose={handleClose}
      labels={modalLabels}
      title={t('question:extrainfo')}
      footer={
        <HyButton variant="secondary" colour="black" onClick={handleClose}>
          {t('question:close')}
        </HyButton>
      }
    >
      <AppMarkdown>{explanationToShow}</AppMarkdown>
    </HyModal>
  )
}

export default ExtraInfoModal
